import { ReactNode, useContext } from 'react';
import { useSessionProvider } from './Session.hook';
import { SessionContext } from './Session.utils';

function SessionProvider({ children }: { children: ReactNode }) {
  const values = useSessionProvider();

  return <SessionContext.Provider value={values}>{children}</SessionContext.Provider>;
}

function useSession() {
  return useContext(SessionContext);
}

export { SessionProvider, useSession };
